"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileNames = exports.STATIC_EXTERNAL_PATH = void 0;
var STATIC_EXTERNAL_PATH = exports.STATIC_EXTERNAL_PATH = '/external/base/img/';
var fileNames = exports.fileNames = {
  AUTO_ANSWER_ONBOARDING: "".concat(STATIC_EXTERNAL_PATH, "chat/auto_answer_onboarding.$ext$"),
  NO_FILTERED_CHATS: "".concat(STATIC_EXTERNAL_PATH, "noFilteredChats.$ext$"),
  HANDSHAKE: "".concat(STATIC_EXTERNAL_PATH, "handshake.$ext$"),
  DEAL: "".concat(STATIC_EXTERNAL_PATH, "/$theme$/chat/deal.$ext$"),
  CROWN_ICON: "".concat(STATIC_EXTERNAL_PATH, "chat/crown.$ext$"),
  PRICING_POWERED_BY_ICON: "".concat(STATIC_EXTERNAL_PATH, "chat/powered_by.$ext$"),
  QUESTION_CLOUD_PLACEHOLDER: "".concat(STATIC_EXTERNAL_PATH, "question_cloud_placeholder"),
  KEY_ICON: "".concat(STATIC_EXTERNAL_PATH, "key_icon.$ext$"),
  IMG_TIPS: "".concat(STATIC_EXTERNAL_PATH, "chat/safety_tips.$ext$"),
  KYC_RECOMMENDED: "".concat(STATIC_EXTERNAL_PATH, "chat/kyc_recommended.$ext$"),
  EMPTY_CHAT: "".concat(STATIC_EXTERNAL_PATH, "/$theme$/emptyChat.$ext$"),
  EMPTY_CHAT_TRANSACTION: "".concat(STATIC_EXTERNAL_PATH, "emptyChatTransaction.svg"),
  KYC_BLOCKED: "".concat(STATIC_EXTERNAL_PATH, "chat/kyc_blocked.$ext$"),
  MEETING_CIRCLE_ICON: "".concat(STATIC_EXTERNAL_PATH, "meetings/meeting-circle.svg"),
  OFFER_CIRCLE_ICON: "".concat(STATIC_EXTERNAL_PATH, "meetings/offer-circle.svg"),
  TRANSACTION_CIRCLE_ICON: "".concat(STATIC_EXTERNAL_PATH, "meetings/transaction-circle.svg"),
  CONFIRMED_STATUS_ICON: "".concat(STATIC_EXTERNAL_PATH, "meetings/confirmed-status.svg"),
  CANCELLED_STATUS_ICON: "".concat(STATIC_EXTERNAL_PATH, "meetings/cancelled-status.svg"),
  PENDING_STATUS_ICON: "".concat(STATIC_EXTERNAL_PATH, "meetings/pending-status.svg"),
  CONFIRMED_BADGE_ICON: "".concat(STATIC_EXTERNAL_PATH, "meetings/confirmed-badge.svg"),
  CANCELLED_BADGE_ICON: "".concat(STATIC_EXTERNAL_PATH, "meetings/cancelled-badge.svg"),
  PENDING_BADGE_ICON: "".concat(STATIC_EXTERNAL_PATH, "meetings/pending-badge.svg"),
  OLXAUTOS_BRANDING: "".concat(STATIC_EXTERNAL_PATH, "/$theme$/chat/inbox_coco.webp"),
  NO_CHATS: "".concat(STATIC_EXTERNAL_PATH, "/$theme$/noChats.$ext$"),
  DISCOUNT_ICON_SMALL: "".concat(STATIC_EXTERNAL_PATH, "/flag_discount_small_v2.svg"),
  DISCOUNT_ICON_MEDIUM: "".concat(STATIC_EXTERNAL_PATH, "/flag_discount_medium_v2.svg"),
  DISCOUNT_ICON_LARGE: "".concat(STATIC_EXTERNAL_PATH, "/flag_discount_large_v2.svg"),
  DISCOUNT_ICON_EXTRA_LARGE: "".concat(STATIC_EXTERNAL_PATH, "/flag_discount_extra_large_v2.svg"),
  IS_AI_VIDEO_AVAIL_MD: "".concat(STATIC_EXTERNAL_PATH, "is_video_avail_md.svg"),
  IS_AI_VIDEO_AVAIL_SM: "".concat(STATIC_EXTERNAL_PATH, "is_video_avail_sm.svg")
};